
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {EventEmitter, Injectable} from '@angular/core';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {PlatformCommand} from '@shared/commands/command-base';
import {CommandService} from '@core/services/command.service';
import {FuseSplashScreenService} from '@barebone-fuse/@fuse/services/splash-screen.service';
import {take} from 'rxjs/operators';
import {Subject} from 'rxjs';
import { Router } from '@angular/router';
import {DialogService} from '@shared/services/dialog-service';
import {PlatformDialogService} from '@shared/components/platform-tool/platform-tool-dialog-definition/services/platform-dialog.service';
import {Api} from '@shared/constants/common-field.constants';
import {Dynamic_Grid_Data_Request_Parameters} from '@shared/store/actions/virtual-grid.actions';
import {ParticleService} from '@core/services/particle.service';
import {ParticleCacheService} from '@core/services/particle-cache.service';
import { SnackBarService } from '@core/services/snack-bar.service';
import {SetCurrentRightSideComponentAction} from "@shared/components/platform-sidebar/store/platform-sidebar.action";
import {Store} from "@ngrx/store";
import {PlatformSidebarState} from "@shared/components/platform-sidebar/store/platform-sidebar.reducer";

@Injectable({
  providedIn: 'root',
})

export class AnalyticReportTemplateHandler implements IPlatformToolHandler {
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  magicLinkModelValueChanged: EventEmitter<any>;
  unsubscribe$ = new Subject<void>();
  showArchived: boolean;
  selectedTab: TabModel;
  sourceType: string;
  metaData: any;
  constructor(private dialogService: DialogService,
              private particleCacheService: ParticleCacheService,
              private commandService: CommandService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private platformSidebarStore: Store<PlatformSidebarState>,
              private snackBarService : SnackBarService,
              private router: Router) {
                this.metaData = {}
  }

  executeCommand(command: PlatformCommand) {
    switch (command.name) {
        case 'ToggleGridFilterByArchiveCommand':
          this.handleToggleGridFilterByArchiveCommand(command);
          break;
      default:
        this.executeCommandToApi(command);
        break;
    }
  }
  private executeCommandToApi(command: PlatformCommand) {
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
          this.fuseSplashScreenService.hide();
          console.log('Command Response', commandResponse);
          // this.commandService.handleResponse(commandResponse);
          if (commandResponse.fieldValues['RedirectCommand']) {
            this.executeCommand(commandResponse.fieldValues['RedirectCommand']);
            return;
          }
          if (commandResponse.fieldValues['PlatformCommand']) {
            this.executeCommand(commandResponse.fieldValues['PlatformCommand']);
            return;
          }
          if (commandResponse.fieldValues['RedirectUrl']) {
            this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
          }
          if(commandResponse.fieldValues['SnackBarMessage']){
            this.snackBarService.showInformation(commandResponse.fieldValues['SnackBarMessage']);
          }
          this.invalidateSubject.invalidate("Refresh");
    },
    error => {
      console.error('Failed To Execute command', error);
      this.fuseSplashScreenService.hide();
    });

  }
}

  setSelectedTab(selectedTab: TabModel): void {
    this.platformSidebarStore.dispatch(
      new SetCurrentRightSideComponentAction(
        {component: 'HelpNotesComponent', data: {isUserAction: false}, componentInfo: {id: 'HelpNotesComponent'}}));
  }

  valueChanged($event) {
    console.log('Inside Handler', $event);
    if (this.handleAction($event)) {
      return;
    }
    if (this.handleCommand($event)) {
      return;
    }
    if (this.handleByFieldDefinition($event)) {
      return;
    }
  }

  private handleAction($event): boolean {
    if ($event.action) {
      switch ($event.action?.id ) {
        case 'Edit':
          this.openEditor($event);
          return true;
        case 'Archive':
          this.archiveReport($event.item, true);
          return true;
        case 'UnArchive':
          this.archiveReport($event.item, false);
          return true;
      }
      return true;
    }
    return false;
  }

  private handleCommand($event): boolean {
    if ($event.command) {
      switch ($event.command.name) {
        case 'CommandName':
          return true;
        default:
          this.executeCommand($event.command);
          return true;
      }
    }
    return false;
  }

  private handleByFieldDefinition($event): boolean {
    const command = this.magicLinkModel.additionalCommands[$event.fieldDefinition.key];
    if (command) {
      command.fieldValues['RelativePath'] = $event.item.cells['ReportFileName'].value;
      command.fieldValues['ReportId'] = $event.item.cells['DisplayId'].value;
      command.fieldValues['ReportDisplayName'] = $event.item.cells['Name'].value;
      command.fieldValues['DefaultGraphId'] = $event.item.cells['DefaultGraphId'].value;
      command.fieldValues['CurrentSchemaAndReportVersion'] =  $event.item.cells['CurrentSchemaAndReportVersion'].value;
      this.executeCommand(command);
      return true;
    }
    return false;
  }

  private openEditor(event: any, type: string = '') {
    const sourceType = this.magicLinkModel.tabBar.tabs[0].tabData['SourceType'];
    const minWidth = '800px';
    const maxWidth = '1500px';
    this.dialogService.showCellEditorDialog(event.item, event.fieldDefinition, minWidth, maxWidth,
      sourceType).subscribe(state => {
      if (state.action === 'OK') {
        const value = event.item.cells[event.fieldDefinition.key]?.value;
        let command;

        switch (sourceType) {
          case 'GMT-Analytic-Report':
            command = this.magicLinkModel?.additionalCommands['UpdateCommand'];
            command.fieldValues['ItemId'] = event.item.id;
            break;
          default:
            break;
        }
        const displayText = event.item.cells[event.fieldDefinition.key]?.displayText;
        command.fieldValues['FieldKey'] = event.fieldDefinition?.key;
        if (displayText) {
          command.fieldValues[event.fieldDefinition.key + 'DisplayText'] = displayText;
        }
        command.fieldValues[event.fieldDefinition.key] = value;
        this.executeCommand(command);
      }
      if (state.action === 'OK' && event.fieldDefinition.metaData['SkipUpdate']) {
        this.invalidateSubject.invalidate();
      }
    });
  }
  private handleToggleGridFilterByArchiveCommand(command: PlatformCommand) {
    const updateViewCommand = new PlatformCommand('GMTAnalyticReportToolLinkCommand', Api.Visualizer);
    updateViewCommand.fieldValues['ShowArchived'] = command.isChecked;
    updateViewCommand.fieldValues['Scope'] = 'GMT';
    this.commandService.executePlatformCommand(updateViewCommand).pipe(take(1)).subscribe(response => {
        console.log('commandState', response);
        if (response.fieldValues['PlatformLinkModel']) {
          this.magicLinkModel = response.fieldValues['PlatformLinkModel'];
          this.sourceType = this.magicLinkModel.tabBar.tabs[0].tabData['SourceType'];
          const params = this.particleCacheService.getUserPreferenceGridSetting(Dynamic_Grid_Data_Request_Parameters, this.sourceType);
          params['ShowArchived'] =  command.isChecked;
          this.particleCacheService.saveUserPreferenceGridSetting(Dynamic_Grid_Data_Request_Parameters, this.sourceType, params);
          this.invalidateSubject.invalidate('Refresh');
        } else {
          console.log('Platform link model not found');
          this.fuseSplashScreenService.hide();
        }
      },
      error => {
        this.fuseSplashScreenService.hide();
        console.error('Operation failed!!!', error);
      });
  }

  private magicLinkModelValueChangedHandler(command: any) {
    this.magicLinkModelValueChanged.emit(command);
  }

  public archiveReport(item, isArchive) {
    const archiveReportCommand = new PlatformCommand('ArchiveAnalyticReportModelCommand', Api.Visualizer);
    archiveReportCommand.setValue('ItemId', item.id);
    archiveReportCommand.setValue('IsArchive', isArchive);
    if (isArchive) {
      this.dialogService.showYesNoDialog('Archive Report', 'Are you sure you want to archive the Report?').subscribe(response => {
        if (response?.action === 'OK') {
          this.commandService.executePlatformCommand(archiveReportCommand).subscribe(commandResponse => {
            this.invalidateSubject.invalidate();
          });
        }
      });
    } else {
      this.commandService.executePlatformCommand(archiveReportCommand).subscribe(commandResponse => {
        this.invalidateSubject.invalidate();
      });
    }

  }


  destroy(): void {
  }
}
